export const ACTIVITY_TABS = [
  { label: "All", value: "all" },
  { label: "Success", value: "success" },
  { label: "Failed", value: "failed" },
];

export const ACTIVITY_SORT_OPTIONS = [
  { label: "Recent", value: "recent" },
  { label: "Oldest", value: "oldest" },
];
